import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';

import { WindowScrollService } from './../../../core/services/window-scroll.service';
import { Column } from './../../table-models';
import { EnvironmentService } from './../../../core/enviroment/environment.service';

interface Contact {
  email: string;
  cellphone: string;
}

interface LeadByBroker {
  client: string;
  company: string;
  avatar: string;
  broker: string;
  product: string;
  contact?: Contact;
}

export interface Lead {
  name: string;
  distributed: number;
  attended: number;
  notAttended: number;
  avatar: string;
  lista: LeadByBroker[];
}

@Component({
  selector: 'app-distribution-broker',
  templateUrl: './distribution-broker.component.html',
  styleUrls: ['./distribution-broker.component.scss', '../../table_leads.scss']
})
export class DistributionBrokerComponent implements OnInit {
  public showFilter: boolean;
  public hasFilter: boolean;
  public selectedLeadsHeaders: Column[];
  public modal2: boolean;
  public titleLeadsModal: string;
  public textFieldSearch = '';
  public options = [];
  public dataSelected = [];
  public data = [
    {
      name: 'Ribeiro (Martins)', distributed: 4, attended: 2, notAttended: 2,
      avatar: 'https://i.imgur.com/I80W1Q0.png',
      lista: [
        {
          client: 'Niels Henrique David Bohr',
          company: 'Lopes São Paulo',
          avatar: 'https://i.imgur.com/I80W1Q0.png',
          broker: 'João (Martins)',
          product: 'Plano e parque do carmo - Iososuke I',
          inclusionData: '05/05/2020 23:45',
          contact: {
            email: 'niels.henrique@gmail.com', cellphone: '(67) 67 98947 - 2324',
          },
        },
        {
          client: 'Niels Henrique David Bohr',
          avatar: 'https://i.imgur.com/I80W1Q0.png',
          company: 'Lopes São Paulo',
          broker: 'Henrique (Martins)',
          product: 'Plano e parque do carmo - Iososuke I',
          inclusionData: '05/05/2020 23:45',
          contact: {
            email: 'niels.david@gmail.com', cellphone: '(67) 67 98794 - 2678',
          },
        }
      ]
    },
    { name: 'Henrique (Martins)', avatar: 'https://i.imgur.com/I80W1Q0.png', distributed: 0, attended: 0, notAttended: 0 },
    {
      name: 'Jeorge (Martins)', distributed: 4, attended: 2, notAttended: 2,
      avatar: 'https://i.imgur.com/I80W1Q0.png',
      lista: [
        {
          client: 'Niels Henrique David Bohr',
          company: 'Lopes São Paulo',
          avatar: 'https://i.imgur.com/I80W1Q0.png',
          broker: 'Ferreira (Martins)',
          product: 'Plano e parque do carmo - Iososuke I',
          inclusionData: '05/05/2020 23:45',
          contact: {
            email: 'niels.henrique@gmail.com', cellphone: '(67) 67 98947 - 2324',
          },
        },
        {
          client: 'Niels Henrique David Bohr',
          avatar: 'https://i.imgur.com/I80W1Q0.png',
          company: 'Lopes São Paulo',
          broker: 'Souza (Martins)',
          product: 'Plano e parque do carmo - Iososuke I',
          inclusionData: '05/05/2020 23:45',
          contact: {
            email: 'niels.david@gmail.com', cellphone: '(67) 67 98794 - 2678',
          },
        }
      ]
    },
    { name: 'Machado (Martins)', avatar: 'https://i.imgur.com/I80W1Q0.png', distributed: 0, attended: 0, notAttended: 0 },
    { name: 'Gonçalves (Martins)', avatar: 'https://i.imgur.com/I80W1Q0.png', distributed: 0, attended: 0, notAttended: 0 },
    { name: 'Silva (Martins)', avatar: 'https://i.imgur.com/I80W1Q0.png', distributed: 0, attended: 0, notAttended: 0 }
  ];
  public showDot: boolean;
  public form: FormGroup;
  public facId: string;
  public showFacModal: boolean;
  public headers: Column[] = [
    {
      label: 'Corretores associados e usuários', id: 'name', sort: true, avatar: true, style: { width: '300px' },
      onClick: (lead) => this.handleOpenLeads(lead)
    },
    {
      label: 'Distribuídos', id: 'distributed', sort: true, style: { width: '120px' }, dotted: true,
      onClick: (lead) => this.handleOpenLeads(lead)
    },
    {
      label: 'Atendidos', id: 'attended', sort: true, style: { width: '120px' }, dotted: true,
      onClick: (lead) => this.handleOpenLeads(lead)
    },
    {
      label: 'Não atendidos', id: 'notAttended', sort: true, style: { width: '120px' }, dotted: true,
      onClick: (lead) => this.handleOpenLeads(lead)
    }
  ];
  public listBinding = [];
  public finished = true;
  public featureInputSearch = false
  
  get hasFinishedLoading(): boolean {
    return this.finished;
  }

  constructor(
    private fb: FormBuilder,
    private windowScroll: WindowScrollService,
    private environmentService: EnvironmentService,
  ) { }

  ngOnInit(): void {
    this.featureInputSearch = this.environmentService.getEnvVar('feature_input_search') === 'true';
    this.form = this.fb.group({
      createTime: [null],
      distributionTime: [null],
      distributionPending: [null]
    });
    this.modal2 = false;
    this.showFilter = false;
    this.hasFilter = false;
    this.selectedLeadsHeaders = [
      { label: 'Cliente', id: 'client', sort: true, avatar: true, style: { width: '300px' } },
      { label: 'Empresa', id: 'company', sort: true, style: { width: '140px' }, onClick: () => this.openFacModal() },
      { label: 'Corretor', id: 'broker', sort: true, style: { width: '140px' }, onClick: () => this.openFacModal() },
      { label: 'Produto', id: 'product', sort: true, style: { width: '255px' }, onClick: () => this.openFacModal() },
      { label: 'Contato', id: 'contact', style: { width: '120px' }, contact: true, onClick: () => this.openFacModal() },
      { label: 'Data da inclusão ', id: 'inclusionData', sort: true, style: { width: '135px' }, onClick: () => this.openFacModal() }
    ];
  }

  public clear() {
    this.hasFilter = false;
    this.form = this.fb.group({
      createTime: [null],
      distributionTime: [null],
      distributionPending: [null]
    });
  }

  public openFacModal() {
    // TODO: remove hard coded facID
    this.windowScroll.enable();
    this.facId = '01278d63-0000-0000-0000-000000000000';
    this.showFacModal = true;
  }

  public closeFacModal() {
    this.facId = null;
    this.showFacModal = false;
  }

  public applyFilter() {
    if (this.validator()) {
      this.hasFilter = true;
    }
    this.showFilter = false;
  }

  public closeLeadsByBroker() {
    this.modal2 = !this.modal2;
    this.titleLeadsModal = null;
    this.dataSelected = [];
    this.windowScroll.enable();
  }

  public handleModal() {
    this.showFilter = !this.showFilter;
  }

  public handleOpenLeads(lead: Lead): void {
    this.titleLeadsModal = lead.name;
    this.dataSelected = lead.lista;
    if (!this.modal2) { this.windowScroll.disable(); }
    this.modal2 = !this.modal2;
  }

  public validator(): boolean {
    return Object.keys(this.form.controls).some(key => !!this.form.get(key).value);
  }

  public disableInput(event) { }

  public searchElement(value) {
    this.options = [{ description: 'Ribeiro', type: 'Corretor' }, { description: 'Henrique', type: 'Corretor' }, { description: 'Jeorge', type: 'Corretor' }, { description: 'Machado', type: 'Corretor' }, { description: 'Gonçalves', type: 'Corretor' }, { description: 'Silva', type: 'Corretor' }];
  }

  public elementSelected(event) { }

  public closedSearch() { }
  public searchInput(data) { }

  public sort(event: MouseEvent, column: Column) {
  }
}
